var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4729_10711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.24998 7.91667V1.66667C1.24998 1.55616 1.29388 1.45018 1.37202 1.37204C1.45016 1.2939 1.55614 1.25 1.66665 1.25H5.41665C5.52715 1.25 5.63313 1.2939 5.71127 1.37204C5.78941 1.45018 5.83331 1.55616 5.83331 1.66667V5H6.66665C6.88766 5 7.09962 5.0878 7.2559 5.24408C7.41218 5.40036 7.49998 5.61232 7.49998 5.83333V7.5C7.49998 7.61051 7.54388 7.71649 7.62202 7.79463C7.70016 7.87277 7.80614 7.91667 7.91665 7.91667C8.02715 7.91667 8.13313 7.87277 8.21127 7.79463C8.28941 7.71649 8.33331 7.61051 8.33331 7.5V4.58333H7.49998C7.38947 4.58333 7.28349 4.53943 7.20535 4.46129C7.12721 4.38315 7.08331 4.27717 7.08331 4.16667V2.6725L6.3929 1.98208L6.98206 1.39292L9.04456 3.45542C9.08331 3.49406 9.11404 3.53997 9.135 3.59053C9.15595 3.64108 9.1667 3.69528 9.16665 3.75V7.5C9.16665 7.83152 9.03495 8.14946 8.80053 8.38388C8.56611 8.6183 8.24817 8.75 7.91665 8.75C7.58513 8.75 7.26718 8.6183 7.03276 8.38388C6.79834 8.14946 6.66665 7.83152 6.66665 7.5V5.83333H5.83331V7.91667H6.24998V8.75H0.833313V7.91667H1.24998ZM2.08331 2.08333V4.58333H4.99998V2.08333H2.08331Z",
    fill: "#9DB2EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4729_10711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.8f9908b5.svg";
export { ForwardRef as ReactComponent };